import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/src/helpers"

const buttonVariants = cva(
  "inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-[var(--qk-paper)] transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--qk-ink)] focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        default: "bg-[var(--qk-ink)] text-[var(--qk-paper)] hover:bg-[var(--qk-ink-2)]",
        destructive:
          "bg-[var(--qk-clay)] text-[var(--qk-paper)] hover:opacity-90",
        outline:
          "border border-[var(--qk-rule)] bg-[var(--qk-paper-3)] text-[var(--qk-ink)] hover:bg-[var(--qk-paper-2)]",
        secondary:
          "bg-[var(--qk-paper-2)] text-[var(--qk-ink)] hover:opacity-80",
        ghost: "hover:bg-[var(--qk-paper-2)] hover:text-[var(--qk-ink)]",
        link: "text-[var(--qk-ink)] underline-offset-4 hover:underline",
      },
      size: {
        default: "h-10 px-4 py-2",
        sm: "h-9 rounded-md px-3",
        lg: "h-11 rounded-md px-8",
        icon: "h-10 w-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    (<Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />)
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
